import { render, staticRenderFns } from "./packageProjects.vue?vue&type=template&id=1c1e85ca"
import script from "./packageProjects.vue?vue&type=script&lang=js"
export * from "./packageProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports